module.exports = __webpack_public_path__ + "img/content.46984811.png";